module.exports = __webpack_public_path__ + "media/images/front/icon_03_tag_gl-bfbba9d1283edd97d25dd39a8144d8e2.png";